import script from "./BeamCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BeamCard.vue?vue&type=script&setup=true&lang=js"

import "./BeamCard.vue?vue&type=style&index=0&id=2498718a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2498718a"]])

export default __exports__